import { select } from 'd3-selection';
import { RefObject } from 'react';

export type SvgProps = {
  height: number;
  chartRef: RefObject<HTMLDivElement>;
  className?: string;
};

export const createSvg = ({
  width,
  height,
  chartRef,
  className = ''
}: SvgProps & { width: number }) => {
  chartRef?.current?.querySelector('svg')?.remove();

  const svg = select(chartRef?.current)
    .append('svg')
    .attr('width', width)
    .attr('height', height)
    .attr('class', className);

  return svg;
};

export const getSafeMargin = (margin?: {
  top?: number;
  right?: number;
  left?: number;
  bottom?: number;
}) => {
  const defaultMargin = { top: 0, right: 0, bottom: 0, left: 0 };
  const safeMargin = { ...defaultMargin, ...(margin || {}) };

  return safeMargin;
};
